const ROLE_CENTRE_READONLY = 'beststart.centreservices.centre.readonly';
const ROLE_CENTRE_READWRITE = 'beststart.centreservices.centre.readwrite';
const ROLE_CENTRE_SUPERADMIN = 'beststart.centreservices.centre.superadmin';

const ROLE_PROPERTY_READONLY = 'beststart.centreservices.property.readonly';
const ROLE_PROPERTY_READWRITE = 'beststart.centreservices.property.readwrite';
const ROLE_PROPERTY_SUPERADMIN = 'beststart.centreservices.property.superadmin';

const ALL_ROLES = [
    ROLE_CENTRE_READONLY,
    ROLE_CENTRE_READWRITE,
    ROLE_CENTRE_SUPERADMIN,
    ROLE_PROPERTY_READONLY,
    ROLE_PROPERTY_READWRITE,
    ROLE_PROPERTY_SUPERADMIN,
];

const ADMINS = [
    ROLE_CENTRE_SUPERADMIN,
    ROLE_PROPERTY_SUPERADMIN,
];

export {
    ROLE_CENTRE_READONLY,
    ROLE_CENTRE_READWRITE,
    ROLE_CENTRE_SUPERADMIN,
    ROLE_PROPERTY_READONLY,
    ROLE_PROPERTY_READWRITE,
    ROLE_PROPERTY_SUPERADMIN,
    ALL_ROLES,
    ADMINS,
};

export default {
    ROLE_CENTRE_READONLY,
    ROLE_CENTRE_READWRITE,
    ROLE_CENTRE_SUPERADMIN,
    ROLE_PROPERTY_READONLY,
    ROLE_PROPERTY_READWRITE,
    ROLE_PROPERTY_SUPERADMIN,
    ALL_ROLES,
    ADMINS,
};